import { commonCrudOption } from '@/const/crud/commonOption'
import { getToken } from '@/utils/auth'

// import store from '@/store'

// var dic = [
//   {
//     label: '是',
//     value: 1
//   },
//   {
//     label: '否',
//     value: 0
//   }
// ]
const isNumberValidator = (rule, value, callback) => {
  if (value && isNaN(value)) {
    callback(new Error('请输入数字'))
  } else {
    callback()
  }
}

// var validatePass = (rule, value, callback, message) => {
//   if (!value) {
//     callback(new Error(message))
//   } else {
//     callback()
//   }
// }

export const getTableOption = (self) => ({
  ...commonCrudOption,
  searchIndex: 2,
  searchSpan: 6,
  searchMenuSpan: 18,
  rowKey: 'code',
  labelWidth: 140,
  tip: false,
  selection: false,
  reserveSelection: true,
  menuWidth: 230,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  tabs: true,
  searchLabelWidth: 100,
  column: [
    // {
    //   label: '房屋架构',
    //   minWidth: 120,
    //   prop: 'pId',
    //   overHidden: true,
    //   viewDisplay: true,
    //   labelWidth: 150,
    //   editDisplay: false,
    //   hide: true,
    //   display: false,
    //   search: true,
    //   searchLabel: '房屋架构',
    //   searchOrder: 100,
    //   type: 'tree',
    //   props: {
    //     children: 'children',
    //     label: 'name',
    //     value: 'code'
    //   },
    //   multiple: true,
    //   dicUrl: process.env.VUE_APP_BASE_API + '/api/v3/asset/tree',
    //   dicQuery: {
    //     organizationId: store.getters.organizationId
    //   },
    //   dicHeaders: {
    //     Authorization: getToken()
    //   },
    //   dicFormatter: (res) => {
    //     return res.data[0].children
    //   }
    // },
    {
      label: '房屋编号',
      prop: 'code',
      minWidth: 200,
      display: false,
      showColumn: false,
      hide: true
    },
    {
      minWidth: 200,
      label: '房屋名称',
      prop: 'name',
      search: true,
      searchOrder: 6,
      overHidden: true,
      display: false
    },
    {
      minWidth: 170,
      display: false,
      label: '公司名称',
      prop: 'customerName',
      overHidden: true
    },
    {
      label: '房屋性质',
      minWidth: 130,
      prop: 'type',
      type: 'select',
      searchTags: true,
      dicUrl: process.env.VUE_APP_BASE_API + '/api/dict/FW-FWXZ',
      search: true,
      searchOrder: 4,
      searchPlaceholder: '请选择',
      display: false,
      dicHeaders: {
        Authorization: getToken()
      },
      props: {
        children: 'children',
        label: 'name',
        value: 'code'
      }
    },
    {
      label: '房屋状态',
      minWidth: 90,
      prop: 'usageStatus',
      searchOrder: 3,
      type: 'select',
      display: false,
      searchTags: true,
      dicUrl: process.env.VUE_APP_BASE_API + '/api/dict/FW-FWZT',
      search: true,
      searchPlaceholder: '请选择',
      dicHeaders: {
        Authorization: getToken()
      },
      props: {
        children: 'children',
        label: 'name',
        value: 'code'
      }
    },
    {
      minWidth: 130,
      label: '产权性质',
      prop: 'ownerType',
      type: 'select',
      searchTags: true,
      display: false,
      dicUrl: process.env.VUE_APP_BASE_API + '/api/dict/FW-FWCQXZ',
      search: true,
      searchOrder: 3,
      searchPlaceholder: '请选择',
      dicHeaders: {
        Authorization: getToken()
      },
      props: {
        children: 'children',
        label: 'name',
        value: 'code'
      },
      control: (val, form) => {
        if (!val) return
        if (val.indexOf('KHCQ') !== -1) {
          return {
            ownerPropertyImgs: {
              display: true
            },
            customerId: {
              display: true
            }
          }
        } else if (val.indexOf('WYCQ') !== -1) {
          return {
            ownerPropertyImgs: {
              display: false
            },
            customerId: {
              display: true
            }
          }
        } else if (val.indexOf('QTCQ') !== -1) {
          return {
            ownerPropertyImgs: {
              display: false
            },
            customerId: {
              display: false
            },
            ownerType: {
              editDisabled: val !== 'FW-FWCQXZ-QTCQ'
            }
          }
        }
      }
    },
    // {
    //   minWidth: 120,
    //   label: '物业接管状态',
    //   display: false,
    //   prop: 'deliveryWyStatus',
    //   dicData: dic
    // },
    {
      minWidth: 120,
      label: '公司名称',
      prop: 'key',
      search: true,
      hide: true,
      display: false,
      showColumn: false,
      searchOrder: 5
    },
    {
      width: 120,
      display: false,
      label: '实测面积(m²)',
      prop: 'areaChar'
    },
    // {
    //   width: 120,
    //   display: false,
    //   label: '建筑面积(m²)',
    //   prop: 'areaBuilding'
    // },
    // {
    //   width: 120,
    //   display: false,
    //   label: '公摊面积(m²)',
    //   prop: 'areaPool'
    // },
    // {
    //   width: 120,
    //   display: false,
    //   label: '套内面积(m²)',
    //   prop: 'areaInside'
    // },
    // {
    //   minWidth: 120,
    //   label: '物业接管状态',
    //   display: false,
    //   prop: 'deliveryWyStatus',
    //   dicData: dic
    // },
    // {
    //   minWidth: 120,
    //   label: '业主接房状态',
    //   display: false,
    //   prop: 'deliveryOwnerStatus',
    //   dicData: dic
    // },

    {
      label: '物业接房日期',
      prop: 'deliveryWyDate',
      width: 180,
      display: false
    },
    {
      label: '合同接房日期',
      prop: 'deliveryOwnerContractDate',
      width: 180,
      display: false
    },
    {
      label: '实际接房日期',
      prop: 'deliveryOwnerDate',
      width: 180,
      display: false
    },
    {
      label: '装修日期',
      prop: 'decorationDate',
      minWidth: 180,
      display: false
    },
    {
      label: '入住日期',
      prop: 'liveDate',
      minWidth: 180,
      display: false
    }
    // {
    //   label: '出租状态',
    //   minWidth: 90,
    //   prop: 'rentStage',
    //   searchOrder: 1,
    //   type: 'select',
    //   searchTags: true,
    //   dicUrl: '/tenantadmin/tenant/dict/item/list?dicCode=asset_rent_stage',
    //   search: true
    // }
  ],
  group: [
    {
      label: '房屋信息',
      icon: 'el-icon-house',
      column: [
        {
          label: '房屋名称',
          prop: 'name',
          rules: [
            {
              required: true,
              message: '请输入房屋名称',
              trigger: 'blur'
            }
          ]
        },
        {
          label: '所在区域',
          prop: 'pId',
          formslot: true,
          viewDisplay: false,
          rules: [
            {
              required: true,
              message: '请选择所在区域',
              trigger: 'blur'
            }
          ]
        },
        {
          label: '所在区域',
          prop: 'location',
          viewDisplay: true,
          editDisplay: false,
          addDisplay: false
        },
        {
          label: '房屋性质',
          prop: 'type',
          type: 'select',
          searchTags: true,
          dicUrl: process.env.VUE_APP_BASE_API + '/api/dict/FW-FWXZ',
          searchPlaceholder: '请选择',
          dicHeaders: {
            Authorization: getToken()
          },
          props: {
            children: 'children',
            label: 'name',
            value: 'code'
          },
          rules: [
            {
              required: true,
              message: '请选择房屋性质',
              trigger: 'blur'
            }
          ]
        },
        {
          label: '房屋状态',
          prop: 'usageStatus',
          type: 'select',
          dicUrl: process.env.VUE_APP_BASE_API + '/api/dict/FW-FWZT',
          searchPlaceholder: '请选择',
          dicHeaders: {
            Authorization: getToken()
          },
          props: {
            children: 'children',
            label: 'name',
            value: 'code'
          },
          rules: [
            {
              required: true,
              message: '请选择房屋状态',
              trigger: 'blur'
            }
          ]
        },
        // {
        //   label: '物业接管状态',
        //   prop: 'deliveryWyStatus',
        //   type: 'radio',
        //   dicData: dic,
        //   span: 12,
        //   rules: [
        //     {
        //       required: true,
        //       message: '请选择房屋性质',
        //       trigger: 'blur'
        //     }
        //   ]
        // },
        // {
        //   label: '业主接房状态',
        //   prop: 'deliveryOwnerStatus',
        //   type: 'radio',
        //   dicData: dic,
        //   rules: [
        //     {
        //       required: true,
        //       message: '请选择房屋性质',
        //       trigger: 'blur'
        //     }
        //   ]
        // },
        {
          label: '物业接管日期',
          prop: 'deliveryWyDate',
          type: 'date',
          valueFormat: 'yyyy-MM-dd',
          rules: [
            {
              required: false,
              message: '请选择物业接管日期',
              trigger: 'blur'
            }
          ]
        },
        {
          label: '合同接房日期',
          prop: 'deliveryOwnerContractDate',
          type: 'date',
          valueFormat: 'yyyy-MM-dd',
          rules: [
            {
              required: true,
              message: '请选择合同接房日期',
              trigger: 'blur'
            }
          ]
        },
        {
          label: '实际接房日期',
          prop: 'deliveryOwnerDate',
          type: 'date',
          valueFormat: 'yyyy-MM-dd',
          rules: [
            {
              required: false,
              message: '请选择实际接房日期',
              trigger: 'blur'
            }
          ]
        },
        {
          label: '装修日期',
          prop: 'decorationDate',
          type: 'date',
          valueFormat: 'yyyy-MM-dd',
          rules: [
            {
              required: false,
              message: '请选择装修日期',
              trigger: 'blur'
            }
          ]
        },
        {
          label: '入住日期',
          prop: 'liveDate',
          type: 'date',
          valueFormat: 'yyyy-MM-dd',
          rules: [
            {
              required: false,
              message: '请选择入住日期',
              trigger: 'blur'
            }
          ]
        },
        {
          label: '实测面积',
          prop: 'areaChar',
          append: '㎡',
          rules: [
            {
              required: true,
              message: '请输入实测面积',
              trigger: 'blur'
            },
            {
              validator: isNumberValidator,
              trigger: 'blur'
            }
          ]
        }
        // {
        //   label: '建筑面积(m²)',
        //   prop: 'areaBuilding',
        //   append: '㎡',
        //   rules: [
        //     {
        //       validator: isNumberValidator,
        //       trigger: 'blur'
        //     }
        //   ]
        // },
        // {
        //   label: '公摊面积(m²)',
        //   prop: 'areaPool',
        //   append: '㎡',
        //   rules: [
        //     {
        //       validator: isNumberValidator,
        //       trigger: 'blur'
        //     }
        //   ]
        // },
        // {
        //   label: '套内面积',
        //   prop: 'areaInside',
        //   append: '㎡',
        //   rules: [
        //     {
        //       validator: isNumberValidator,
        //       trigger: 'blur'
        //     }
        //   ]
        // }
        // {
        //   label: '赠送面积',
        //   prop: 'areaNoprice',
        //   span: 12,
        //   append: '㎡',
        //   rules: [
        //     {
        //       validator: isNumberValidator,
        //       trigger: 'blur'
        //     }
        //   ]
        // }

      ]
    },
    {
      label: '产权信息',
      icon: 'el-icon-postcard',
      column: [
        {
          label: '产权性质',
          prop: 'ownerType',
          dicUrl: process.env.VUE_APP_BASE_API + '/api/dict/FW-FWCQXZ',
          dicHeaders: {
            Authorization: getToken()
          },
          props: {
            children: 'children',
            label: 'name',
            value: 'code'
          },
          editDisabled: true,
          type: 'select',
          minWidth: 100,
          rules: [
            {
              required: false,
              message: '请选择产权性质',
              trigger: 'blur'
            }
          ]
        },
        {
          label: '房产证明',
          prop: 'ownerPropertyImgs',
          component: 'DyImageUpload',
          labelInValue: true,
          biztype: 'identityhouse',
          display: false
        },
        {
          label: '公司名称',
          prop: 'customerId',
          formslot: true,
          display: false,
          rules: [
            {
              required: true,
              message: '请选择公司名称',
              trigger: 'blur'
            }
          ]
        }
      ]
    }
  ]
})

export const getHouseholdTableOption = () => ({
  border: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  index: false,
  searchBtn: false,
  refreshBtn: false,
  menu: false,
  columnBtn: false,
  column: [
    {
      minWidth: 150,
      label: '住户名称',
      prop: 'name'
    },
    {
      minWidth: 150,
      label: '住户联系电话',
      prop: 'phone'
    },
    {
      minWidth: 150,
      label: '证件类型',
      prop: 'identityType',
      dicUrl: process.env.VUE_APP_BASE_API + '/tenantadmin/tenant/dict/item/list?dicCode=identity_type'
    },
    {
      minWidth: 150,
      label: '证件号码',
      prop: 'identityNo'
    },
    {
      minWidth: 150,
      label: '身份类型',
      prop: 'customerProperty',
      dicUrl: process.env.VUE_APP_BASE_API + '/tenantadmin/tenant/dict/item/list?dicCode=customer_property'
    }
  ]
})

export const getParkTableOption = () => ({
  border: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  index: false,
  searchBtn: false,
  refreshBtn: false,
  menu: false,
  columnBtn: false,
  column: [
    {
      minWidth: 100,
      label: '车位编号',
      prop: 'carportNo'
    },
    {
      minWidth: 100,
      label: '车位类别',
      prop: 'carportTypeId',
      dicUrl: process.env.VUE_APP_BASE_API + '/tenantadmin/tenant/dict/item/list?dicCode=carport_type'
    },
    {
      minWidth: 100,
      label: '产权归属',
      prop: 'propertyOwnerType',
      dicUrl:
        '/tenantadmin/tenant/dict/item/list?dicCode=carport_property_type'
    },
    {
      minWidth: 100,
      label: '公司名字',
      prop: 'propertyOwners'
    },
    {
      minWidth: 150,
      overHidden: true,
      label: '关联车辆',
      prop: 'plateNos'
    }
  ]
})

export const getHouseUnpayOption = () => ({
  border: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  maxHeight: 400,
  index: false,
  searchBtn: false,
  refreshBtn: false,
  menu: false,
  columnBtn: false,
  column: [
    {
      minWidth: 150,
      label: '房屋名称',
      prop: 'assetName'
    },
    {
      minWidth: 150,
      label: '车位名称',
      prop: 'parkspotName'
    },
    {
      minWidth: 150,
      label: '费用日期',
      prop: 'feesDate'
    },
    {
      minWidth: 150,
      label: '房屋编号',
      prop: 'houseCode'
    },
    {
      minWidth: 150,
      label: '费用开始日期',
      prop: 'feesStartDate'
    },
    {
      minWidth: 150,
      label: '费用结束时间',
      prop: 'feesEndDate'
    },
    {
      minWidth: 150,
      label: '收费科目名称',
      prop: 'accountName'
    },
    {
      minWidth: 150,
      label: '总金额',
      prop: 'amountTotal'
    },
    {
      minWidth: 150,
      label: '累计减免金额',
      prop: 'amountReduce'
    },
    {
      minWidth: 150,
      label: '欠费金额',
      prop: 'amountTopay'
    },
    {
      minWidth: 150,
      label: '违约金金额',
      prop: 'amountLatefeePaid'
    },
    {
      minWidth: 150,
      label: '违约金减免金额',
      prop: 'amountLatefeeReduce'
    },
    {
      minWidth: 150,
      label: '违约金待支付金额',
      prop: 'amountLatefeeTopay'
    },
    {
      minWidth: 150,
      label: '账单缴费金额',
      prop: 'amountPaid'
    }
  ]
})

export const getTransferTableOption = () => ({
  border: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  index: false,
  searchBtn: false,
  refreshBtn: false,
  menu: false,
  columnBtn: false,
  column: [
    {
      minWidth: 100,
      label: '新公司名称',
      overHidden: true,
      prop: 'newCustomerNames'
    },
    {
      minWidth: 240,
      label: '新业主房产证',
      prop: 'propertyImg1'
    },
    {
      minWidth: 100,
      label: '老业主名称',
      overHidden: true,
      prop: 'customerNames'
    },
    {
      minWidth: 130,
      label: '老业主联系电话',
      overHidden: true,
      prop: 'customerPhones'
    },
    // {
    //   minWidth: 150,
    //   label: "证件类型",
    //   prop: "identityType",
    //   dicUrl: '/tenantadmin/tenant/dict/item/list?dicCode=identity_type',
    // },
    {
      minWidth: 150,
      label: '老业主证件号码',
      overHidden: true,
      prop: 'customerIdentityNos'
    },
    {
      minWidth: 175,
      label: '老业主入住时间',
      prop: 'propertyTime'
    },
    {
      minWidth: 175,
      label: '老业主系统转出时间',
      prop: 'transferDate'
    }
  ]
})

export const getTransferMemberOption = () => ({
  border: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  index: false,
  searchBtn: false,
  refreshBtn: false,
  menu: false,
  columnBtn: false,
  column: [
    {
      minWidth: 150,
      label: '住户姓名',
      prop: 'memberName'
    },
    {
      minWidth: 150,
      label: '联系电话',
      prop: 'mobile'
    },
    {
      minWidth: 150,
      label: '住户类型',
      prop: 'liveType',
      dicUrl: process.env.VUE_APP_BASE_API + '/api/dict/KH-JTCYLX',
      dicHeaders: {
        Authorization: getToken()
      },
      props: {
        children: 'children',
        label: 'name',
        value: 'code'
      }
    },
    {
      minWidth: 150,
      label: '是否保留住户',
      prop: 'option'
    }
  ]
})

export const getProjectAssetsTreeFormOption = () => ({
  submitBtn: false,
  emptyBtn: false,
  labelWidth: 120,
  column: [
    {
      label: '名称',
      prop: 'name',
      required: true,
      span: 24,
      rules: [
        {
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }
      ]
    },
    {
      label: '类型',
      prop: 'type',
      type: 'select',
      required: true,
      dicUrl: `${process.env.VUE_APP_BASE_API}/api/dict/ZCLX-FYGL-XQXM`,
      editDisabled: true,
      props: {
        label: 'name',
        value: 'code'
      },
      dicHeaders: {
        Authorization: getToken()
      },
      rules: [
        {
          required: true,
          message: '请选择类型',
          trigger: 'blur'
        }
      ],
      span: 24
    },
    {
      label: '描述',
      editDisabled: true,
      prop: 'description',
      span: 24
    },
    {
      label: '管家微信/企微',
      prop: 'housekeeper',
      span: 24,
      component: 'DyImageUpload',
      width: 148,
      height: 148,
      biztype: 'housekeeper',
      limit: 1
    }
    // {
    //   label: '层级',
    //   editDisabled: true,
    //   prop: 'levelName',
    //   type: 'radio',
    //   value: 1,
    //   span: 24,
    //   dicData: [
    //     { value: 1, label: '同一层级' },
    //     { value: 2, label: '下级房源' }
    //   ]
    // }
  ]
})
